<div
  class="ui-invoice-capture"
  [class.ui-invoice-capture--scrollable]="scrollable()"
>
  <ui-form-section
    class="ui-invoice-capture__files"
    [title]="filesTitle()"
    [fill]="true"
  >
    @if (manualValidation()) {
      <ui-button
        actions
        size="sm"
        [loading]="validating()"
        (pressed)="onValidate()"
      >
        Validar
      </ui-button>
    }
    <div class="ui-invoice-capture__fields">
      @if (saveError()) {
        <p class="ui-invoice-capture__error" role="alert">{{ saveError() }}</p>
      }
      <ui-file-upload
        label="Archivos XML y PDF"
        [required]="true"
        [multiple]="true"
        [accept]="fileAccept"
        [maxSizeMB]="20"
        [block]="true"
        [(value)]="files"
      />
      @if (showNotes()) {
        <ui-textarea label="Notas" [block]="true" [(value)]="notes" />
      }
    </div>
  </ui-form-section>

  <ui-form-section
    class="ui-invoice-capture__validation"
    [title]="validationTitle()"
    [fill]="true"
  >
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="criteriaOrigin()!"
      [cdkConnectedOverlayOpen]="infoOpen() && !!criteriaOrigin()"
      [cdkConnectedOverlayPositions]="criteriaPositions()"
      [cdkConnectedOverlayPush]="true"
      [cdkConnectedOverlayViewportMargin]="12"
      (overlayOutsideClick)="closeCriteria()"
    >
      <div
        class="ui-invoice-capture__info-panel"
        [style.width.px]="panelWidth()"
      >
        <div class="ui-invoice-capture__info-panel-actions">
          <strong
            class="ui-invoice-capture__info-panel-title"
            [title]="criteriaTitle()"
          >{{ criteriaTitle() }}</strong>
          <ui-button variant="ghost" size="sm" (pressed)="closeCriteria()">Cerrar</ui-button>
        </div>
        <ng-content select="[validation-menu]" />
      </div>
    </ng-template>
    @if (!manualValidation()) {
      <p class="ui-invoice-capture__validation-note">
        La validación confirma localmente que el archivo tiene una estructura CFDI interpretable;
        no realiza una consulta en línea al SAT.
      </p>
    }
    @if (!manualValidation() || !showValidatedTable()) {
      <ng-content select="[validation-intro]" />
    }
    @if (!manualValidation() || showValidatedTable()) {
    <ui-data-table
      [columns]="tableColumns()"
      [rows]="visibleDrafts()"
      [total]="visibleDrafts().length"
      [showNewButton]="false"
      [showPageSize]="false"
      [showPagination]="false"
      [showExcel]="false"
      [showActionsColumn]="false"
      [showColumnFilters]="manualValidation()"
      [segmentedFilters]="manualValidation() ? validationSegments() : []"
      [verticalScroll]="manualValidation()"
      [verticalScrollFill]="manualValidation()"
      [showTotals]="manualValidation()"
      [columnsToTotal]="manualTotalColumns"
      [totalsOverride]="manualValidation() ? draftTotals() : null"
      [sortingEnabled]="false"
      columnSizing="fixed"
      rowKey="id"
      (columnFiltersChange)="onDraftColumnFilters($event)"
      (segmentedFiltersChange)="onDraftSegment($event)"
      (tagClick)="onValidationTag($event)"
    />
    }
  </ui-form-section>
</div>
